var _defs, _g, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRuler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.85 19.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n      .cls-2 {\n        mask: url(#mask);\n      }\n      .cls-3,\n      .cls-4 {\n        fill: none;\n        stroke: #00b3ff;\n      }\n      .cls-3 {\n        stroke-width: 3px;\n      }\n      .cls-4 {\n        stroke-width: 1.5px;\n      }\n    "), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 19.85,
    height: 19.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.03 -1.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-1-inside-1_8678_39502",
    "data-name": "path-1-inside-1 8678 39502"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.45,
    y: 7.86,
    width: 17,
    height: 8,
    rx: 1,
    transform: "translate(-4.89 11.92) rotate(-45)"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "transparent",
    stroke: "currentColor",
    x: 3.45,
    y: 7.86,
    width: 17,
    height: 8,
    rx: 1,
    strokeWidth: 2.5,
    transform: "translate(-6.91 9.99) rotate(-45)"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.7,
    y1: 10.07,
    x2: 7.53,
    y2: 12.9,
    fill: "currentColor",
    stroke: "currentColor"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.35,
    y1: 4.42,
    x2: 13.18,
    y2: 7.24,
    fill: "currentColor",
    stroke: "currentColor"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.53,
    y1: 7.24,
    x2: 9.65,
    y2: 9.37,
    fill: "currentColor",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.52bb7f42.svg";
export { ForwardRef as ReactComponent };